import { cursos } from "../assets/InfoCursos";

export const resolveCourse = (family, slug) =>
    cursos.find((curso) => {
        if (curso.routeFamily === family && curso.routeSlug === slug) {
            return true;
        }

        return (curso.routeAliases || []).some(
            (alias) => alias.family === family && alias.slug === slug,
        );
    });

export const getCoursePath = (curso) =>
    `/${curso.routeFamily}/${curso.routeSlug}`;

export const getEnrollmentPath = (curso) =>
    `${getCoursePath(curso)}/inscripcion`;

export const getEnrollmentSuccessPath = (curso) =>
    `${getEnrollmentPath(curso)}/confirmacion`;
